import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import history from '../../../core/history';
import AccountViews from '../../AccountGetsMarried/constants/AccountViews';
import { setAjaxError, setAjaxPending } from '../../../actions/runtime';
import { receiveUserProfileForAccount } from '../../../actions/account';
import { apiPostDispatchable } from '../../../core/dapi';
import { createUserProfileUrl } from '../../../core/dapi/userProfile';
import { ACCOUNT_HOME_PATH } from '../../../constants/index';
import { NativeFunctions } from '~/core/util/native';

export default (onClose: any) => {
  const dispatch = useDispatch();

  return useCallback(
    (userProfileData) => {
      dispatch(setAjaxPending(true));

      const onSuccess = (response: any) => {
        dispatch(setAjaxPending(false));
        history.push(`${ACCOUNT_HOME_PATH}/${response.id}/${AccountViews.GetCare}`);
        onClose();
        NativeFunctions.askForRating.call();
        return receiveUserProfileForAccount(response);
      };

      dispatch(
        apiPostDispatchable(createUserProfileUrl(), userProfileData, onSuccess, setAjaxError)
      );
    },
    [dispatch, onClose]
  );
};
